var exports = {
  "kL": "x28a7bf27--85aac4--container",
  "Zd": "x28a7bf27--85aac4--form",
  "DD": "x28a7bf27--85aac4--title",
  "Qs": "x28a7bf27--85aac4--content",
  "hF": "x28a7bf27--85aac4--input",
  "z3": "x28a7bf27--85aac4--error",
  "x6": "x28a7bf27--85aac4--button",
  "qr": "x28a7bf27--85aac4--footer",
  "o2": "x28a7bf27--85aac4--agreement-link",
};

module.exports = exports;
